// Wrapped in an IIFE so this section's script (which is re-inserted into the
// page any time this section is re-rendered, e.g. in the theme editor) never
// throws "Identifier has already been declared" from redeclaring top-level
// const/class bindings, and so its names don't collide with other section
// scripts (store-change-bar.js also declares a LATE_LOADING_SELECTORS const).
(function () {
  if (customElements.get("global-store-popup")) return;

  const GLOBAL_STORE_POPUP_COOKIE = "global-store-popup-closed";
  const GLOBAL_STORE_POPUP_COOKIE_DAYS = 7;

  // Classes for add-to-cart and checkout buttons to hide when store is not for India but visitor is in India
  const ADD_TO_CART_AND_CHECKOUT_BUTTONS = [
    ".product-form__buttons",
    ".product-card__add-to-cart--form",
    ".product-recommendations",
    "#select_custom_size_btn",
    ".product-card__add-to-cart--button",
    ".product-form__submit",
    '[name="checkout"]',
    ".product__size_picker",
  ];

  const LATE_LOADING_SELECTORS = [".wpe-card__add, .wpe-card__cart-btn"];

  class GlobalStorePopup extends ModalDialog {
    constructor() {
      super();
      if (Shopify.designMode) {
        window.addEventListener("shopify:section:load", this.init.bind(this));
      }
    }

    shouldRestrictPurchasing(storeRegion, country) {
      // User from India browsing global store → restrict add to cart / checkout
      if (storeRegion === "Global") return country === "IN";
      return false;
    }

    hidePurchaseButtons() {
      ADD_TO_CART_AND_CHECKOUT_BUTTONS.forEach(function (btn) {
        document.querySelectorAll(btn).forEach(function (el) {
          if (el) {
            el.style.display = "none";
          }
        });
      });
      function hideLate() {
        LATE_LOADING_SELECTORS.forEach(function (sel) {
          document.querySelectorAll(sel).forEach(function (el) {
            el.style.display = "none";
          });
        });
      }

      hideLate();

      const observer = new MutationObserver(hideLate);
      observer.observe(document.body, { childList: true, subtree: true });
    }

    hide() {
      super.hide();
      setCookie(
        GLOBAL_STORE_POPUP_COOKIE,
        "true",
        GLOBAL_STORE_POPUP_COOKIE_DAYS,
      );
    }

    connectedCallback() {
      if (Shopify.designMode) {
        if (this.dataset.openInDesignMode === "true") {
          this.show();
        }
        return;
      }

      this.storeRegion = Shopify.currency.active === "USD" ? "Global" : "India";
      this.closed = getCookie(GLOBAL_STORE_POPUP_COOKIE);

      this.fetchCountryAndUpdatePopup();
    }

    getVisitorCountry() {
      const url = "https://get.geojs.io/v1/ip/country.json";

      return fetch(url)
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          const country = data?.country || null;
          return country;
        })
        .catch(function () {
          return null;
        });
    }

    shouldShowForRegion(storeRegion, country) {
      if (storeRegion === "always") return true;
      if (storeRegion === "India") return country !== "IN";
      // User from India browsing global store → show popup
      if (storeRegion === "Global") return country === "IN";
      return true;
    }

    fetchCountryAndUpdatePopup() {
      const self = this;

      this.getVisitorCountry().then(function (country) {
        self.country = country;

        if (self.shouldRestrictPurchasing(self.storeRegion, country)) {
          self.hidePurchaseButtons();
        }

        if (self.closed === "true") return;
        if (!self.shouldShowForRegion(self.storeRegion, country)) return;
        self.show();
      });
    }
  }

  customElements.define("global-store-popup", GlobalStorePopup);
})();
